import { getParamsFromUrl } from 'utils/placement-helper-utils'
import { get, isEmpty, isEqual } from 'lodash'
import { mapKeywordsWithApi, getTags } from './helpers'

export const mediationEvents = [
  'adRequested',
  'adAvailable',
  'adLoaded',
  'adNoBid',
  'adBadRequest',
  'adRequestFailure',
]

export const getApn = () => {
  const win = typeof window !== 'undefined' ? window : {}
  win.apntag = win.apntag || {}
  win.apntag.anq = win.apntag.anq || []
  const apnTag = win.apntag
  const apnQueue = apnTag.anq
  return {
    apnTag,
    apnQueue,
  }
}

export const setDebugParams = () => {
  const debugParams = getParamsFromUrl('ast_')
  const { apnTag } = getApn()
  Object.keys(debugParams).forEach((key) => {
    if (debugParams[key] === 'true') {
      apnTag[key] = true
    } else if (debugParams[key] === 'false') {
      apnTag[key] = false
    } else {
      apnTag[key] = decodeURIComponent(debugParams[key])
    }
  })
  // apnTag['debug'] = true
}

export const unloadAd = (id) => {
  const adContainer = document.getElementById(id)
  if (adContainer) {
    while (adContainer.firstElementChild) {
      adContainer.removeChild(adContainer.firstElementChild)
    }
  }

  const { apnTag } = getApn()
  if (Object.prototype.hasOwnProperty.call(apnTag, 'clearRequest')) {
    apnTag.clearRequest()
  }
}

export const shouldSetPageOptions = (newKeywords) => {
  const { apnTag } = getApn()
  const pageOptionsNotSet = get(apnTag, 'requests.member') === undefined
  const oldKeywords = get(apnTag, 'requests.keywords', {})
  const shouldRefreshPageOptions = !isEmpty(newKeywords) && !isEqual(oldKeywords, newKeywords)
  return pageOptionsNotSet || shouldRefreshPageOptions
}

const readFromPulse2DataCookie = (position) => {
  const cookie =
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          `(?:(?:^|.*;)\\s* ${encodeURIComponent('_pulse2data').replace(
            /[-.+*]/g,
            '\\$&',
          )}\\s*\\=\\s*([^;]*).*$)|^.*$`,
        ),
        '$1',
      ),
    ) || false
  if (cookie) {
    return cookie.split(',')[position]
  }
  return null
}

export const setPageOptions = ({ inventory, device, loggedIn }) => {
  const { apnTag, apnQueue } = getApn()
  setDebugParams()
  const clientKeywords = get(inventory, 'context.appnexus.client_keywords')
  const apiKeywords = get(inventory, 'context.appnexus.api_keywords')
  let keywords = mapKeywordsWithApi(clientKeywords, { device, loggedIn })
  const tags = getTags()

  // Set glimr keywords
  if (tags && tags.length > 0) {
    keywords = Object.assign(keywords, apiKeywords, {
      'se-generic-geo': tags,
      'se-generic-weather': tags,
    })
  }

  // Set Ast Version
  const astVersion = apnTag.getAstVersion
  if (typeof astVersion === 'function') {
    keywords = Object.assign(keywords, {
      'se-generic-sdk-version': astVersion(),
    })
  }

  // set externalID source
  const externalUid = readFromPulse2DataCookie(9)
  const userID = readFromPulse2DataCookie(2)

  keywords = Object.assign(keywords, {
    /* eslint-disable-next-line */
    'se-generic-externalid_src': externalUid ? (userID ? 2 : 1) : 0,
  })

  /**
   * Modifying Keywords accroding to URL params
   * read all keywords from url starts with kv_
   * add or update
   */
  const urlKeywords = getParamsFromUrl('kv_')
  keywords = Object.assign(keywords, urlKeywords)
  /* Set page keywords */
  const options = {
    keywords,
    user: {
      externalUid: readFromPulse2DataCookie(9),
    },
  }

  if (!shouldSetPageOptions(keywords)) return
  apnQueue.push(() => {
    apnTag.setPageOpts(options)
  })
}

export const attachMediationListeners = () => {}
export const revokeMediationListeners = (id) => {
  const { apnTag, apnQueue } = getApn()
  apnQueue.push(() => {
    mediationEvents.map((eventType) => apnTag.offEvent(eventType, id))
  })
}

export const disposeAd = (id) => {
  unloadAd(id)
  revokeMediationListeners(id)
}

export const resizeAd = (id) => {
  const { apnTag, apnQueue } = getApn()
  apnQueue.push(() => {
    apnTag.resizeAd(id, ['100%', '100%'])
  })
}

export const showTag = (id) => {
  const { apnTag, apnQueue } = getApn()
  apnQueue.push(() => {
    if (Object.prototype.hasOwnProperty.call(apnTag, 'showTag')) {
      apnTag.showTag(id)
    }
  })
}
